import { Component, forwardRef, input } from '@angular/core';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { DateRangeObject } from '@models/date-range';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { toValidDate } from '@/utils/date-utils';

@Component({
  selector: 'wr-datetime-range-picker',
  standalone: false,
  templateUrl: './date-time-range-picker.component.html',
  styleUrls: ['./date-time-range-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateTimeRangePickerComponent),
      multi: true,
    },
  ],
})
export class DateTimeRangePickerComponent extends AbstractFormControl<DateRangeObject>{
  readonly placeholder = input('Datum wählen');

  readonly min = input<Date | string>();

  readonly max = input<Date | string>();

  private swapIfInverted(): void {
    const value = this.value;
    const start = toValidDate(value?.start);
    const end = toValidDate(value?.end);
    if (!value || !start || !end || start.getTime() <= end.getTime()) return;
    this.value = {
      start: value.end!,
      end: value.start,
    };
  }

  get startDate(): Date | string | undefined {
    return this.value?.start;
  }

  set startDate(date: Date | string | undefined) {
    if (!date) {
      this.value = undefined;
      return;
    }
    this.value = {
      start: date,
      end: this.value?.end ?? date,
    };
    this.swapIfInverted();
  }

  get endDate(): Date | string | undefined {
    return this.value?.end;
  }

  set endDate(date: Date | string | undefined) {
    if (!date) {
      this.value = this.value && { start: this.value.start, end: undefined };
      return;
    }
    this.value = {
      start: this.value?.start ?? date,
      end: date,
    };
    this.swapIfInverted();
  }
}
